import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-enterprise-unified-process',
  templateUrl: './enterprise-unified-process.component.html',
  styleUrls: ['./enterprise-unified-process.component.scss']
})
export class EnterpriseUnifiedProcessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
